import Typography from '@mui/material/Typography';
import styled from 'styled-components';

import {
  BaseColorKeys, SubjectColorKeys,
} from '../../theme';

interface Colorable {
  textcolor: BaseColorKeys | SubjectColorKeys
}

const BookletName = styled(Typography)<Colorable>`
&& {
  color: ${({ theme, textcolor }) => theme.palette[textcolor].dark};
  font-weight: 'bold';
}
`;

export { BookletName };
